/** ----------------------------------------
     State
 ---------------------------------------- */

const state = () => {
    return {
        data: [
            {
                template: 'home',
                content: {
                    header: {
                        size: 'large',
                        subtitle: {
                            eng: 'We help brands grow',
                            nl: 'Wij helpen merken groeien'
                        },
                        title: {
                            eng: 'Design-driven digital agency for ambitious brands.',
                            nl: 'Design gedreven agency voor ambitieuze merken.'
                        },
                        button: {
                            href: '#',
                            text: {
                                eng: 'Find out what we do',
                                nl: 'Wat wij doen'
                            }
                        }
                    },
                    summary: {
                        size: 'medium',
                        subtitle: {
                            eng: 'Together, we can build the best solutions',
                            nl: 'Samen bouwen we aan de beste oplossingen'
                        },
                        title: {
                            eng: 'We focus on your challenges through kickass <i>brand design</i> & <i>strategy</i> while <i>developing</i> your most complex and desired web-apps.',
                            nl: 'We focus on your challenges through kickass <i>brand design</i> & <i>strategy</i> while <i>developing</i> your most complex and desired web-apps.'
                        },
                        button: {
                            href: '#',
                            text: {
                                eng: 'View our services',
                                nl: 'Bekijk onze diensten'
                            }
                        }
                    },
                    highlight: {
                        size: 'medium',
                        subtitle: {
                            eng: 'We are Vruchtvlees',
                            nl: 'Wij zijn Vruchtvlees'
                        },
                        title: {
                            eng: 'A creative branding and web design agency based in the Netherlands',
                            nl: 'Een creatief bureau en digitaal agency voor web design in Den Haag'
                        },
                        button: {
                            href: '#',
                            type: 'about',
                            text: {
                                eng: 'View our services',
                                nl: 'Bekijk onze diensten'
                            }
                        }
                    },
                    work: {
                        size: 'medium',
                        subtitle: {
                            eng: 'Our work',
                            nl: 'Ons werk'
                        },
                        title: {
                            eng: 'We bring brands to life.',
                            nl: 'Wij brengen merken tot leven'
                        },
                        button: {
                            href: '#',
                            text: {
                                eng: 'View all our cases',
                                nl: 'Bekijk al onze projecten'
                            }
                        }
                    },
                    overview: {
                        type: 'crooked'
                    },
                    related: [
                        {
                            title: {
                                eng: 'Our work',
                                nl: 'Ons werk'
                            },
                            text: {
                                eng: 'Challenges we’ve solved',
                                nl: 'Uitdagingen die we hebben opgelost'
                            },
                            route: {
                                type: 'work'
                            }
                        },
                        {
                            title: {
                                eng: 'About us',
                                nl: 'Over ons'
                            },
                            text: {
                                eng: 'How we do what we do',
                                nl: 'Hoe we doen wat we doen'
                            },
                            route: {
                                type: 'about'
                            }
                        }
                    ]
                }
            },
            {
                template: 'about',
                content: {
                    header: {
                        size: 'medium',
                        subtitle: {
                            eng: 'We are Vruchtvlees',
                            nl: 'Wij zijn Vruchtvlees'
                        },
                        title: {
                            eng: 'We help ambitious brands grow by fusing digital, strategy, and design.',
                            nl: 'Wij helpen ambitieze merken te laten groeien door met strategie, design en digitale oplossingen.'
                        },
                    },
                    about: {
                        size: 'small',
                        title: {
                            nl: 'Digital solutions, driven by design.',
                            eng: 'Digitale oplossingen gedreven door design.'
                        },
                        text: {
                            eng: 'Vruchtvlees is a design-driven digital agency that realises the potential of ambitious brands. Through our Dutch Digital Design vision, we build brands, digital platforms, websites and content that people love and help companies grow. In close collaboration with our clients, we create internationally renowned human-centered products that enhance interaction and conversion.',
                            nl: 'Vruchtvlees is a design-driven digital agency that realises the potential of ambitious brands. Through our Dutch Digital Design vision, we build brands, digital platforms, websites and content that people love and help companies grow. In close collaboration with our clients, we create internationally renowned human-centered products that enhance interaction and conversion.'
                        }
                    },
                    strategy: {
                        size: 'medium',
                        subtitle: {
                            eng: 'Creating your experiences',
                            nl: 'Ontwerpen jou ervaring'
                        },
                        title: {
                            eng: 'We do strategy',
                            nl: 'Wij doen strategie'
                        },
                        text: {
                            eng: 'Only on a solid strategic foundation, one can start building. Therefore, our Dutch Digital Design is grounded in a strategic process. Whether it is about the brand, marketing, content, social media or user experience, we research the brand/product thoroughly and provide strategic guidelines to help communicate in better ways.<br><br>We believe the digital world becomes a better place when design-driven solutions are provided. We adapt our services to your needs and are engaged sparring partners in the process. Together, we can build the best solutions to conquer overarching challenges. Like we did for <i>Dutch Design Week</i>, <i>Miro</i> and <i>Theater Rotterdam</i>.',
                            nl: 'Only on a solid strategic foundation, one can start building. Therefore, our Dutch Digital Design is grounded in a strategic process. Whether it is about the brand, marketing, content, social media or user experience, we research the brand/product thoroughly and provide strategic guidelines to help communicate in better ways.<br><br>We believe the digital world becomes a better place when design-driven solutions are provided. We adapt our services to your needs and are engaged sparring partners in the process. Together, we can build the best solutions to conquer overarching challenges. Like we did for <i>Dutch Design Week</i>, <i>Miro</i> and <i>Theater Rotterdam</i>.'
                        },
                        button: {
                            id: 1,
                            type: 'page',
                            slug: 'digital',
                            text: {
                                eng: 'Read more about how we do strategy',
                                nl: 'Bekijk hoe we strategie inzetten'
                            }
                        },
                        cases: [
                            'Dutch Design Week',
                            'Theater de Vest / Grote Kerk Alkmaar'
                        ]
                    },
                    design: {
                        size: 'medium',
                        subtitle: {
                            eng: 'Creating your experiences',
                            nl: 'Prachtige ontwerpen'
                        },
                        title: {
                            eng: 'We design',
                            nl: 'Wij ontwerpen'
                        },
                        text: {
                            eng: 'When the strategic foundation is set, we start the creative process. We use creation sprints to explore different directions, create vibrant brand identities, provide extensive identity guidelines, build wireframes and work on deliverables and animations that focus on enhancing user experiences across every touchpoint.',
                            nl: 'When the strategic foundation is set, we start the creative process. We use creation sprints to explore different directions, create vibrant brand identities, provide extensive identity guidelines, build wireframes and work on deliverables and animations that focus on enhancing user experiences across every touchpoint.'
                        },
                        button: {
                            id: 2,
                            type: 'page',
                            slug: 'strategy',
                            text: {
                                eng: 'Read more about our design methods',
                                nl: 'Lees verder over ons design proces'
                            }
                        },
                        cases: [
                            'Miro',
                            'Dutch Design Week'
                        ]
                    },
                    digital: {
                        size: 'medium',
                        subtitle: {
                            eng: 'The digital landscape',
                            nl: 'Het digitale landschap'
                        },
                        title: {
                            eng: 'We develop',
                            nl: 'Wij ontwikkelen'
                        },
                        text: {
                            eng: 'Set in the digital age, Vruchtvlees aims to bring the Dutch Design tradition to the digital world. We develop digital applications that scale on any device, responsive and adaptive to the users needs. At the same time, we incorporate intuitive solutions that help our clients to easily maintain and update the website by using a modern stack of tools, as well as connecting third-party API’s.',
                            nl: 'Set in the digital age, Vruchtvlees aims to bring the Dutch Design tradition to the digital world. We develop digital applications that scale on any device, responsive and adaptive to the users needs. At the same time, we incorporate intuitive solutions that help our clients to easily maintain and update the website by using a modern stack of tools, as well as connecting third-party API’s.'
                        },
                        button: {
                            id: 3,
                            type: 'page',
                            slug: 'design',
                            text: {
                                eng: 'Read how we approach digital',
                                nl: 'Bekijk ons ontwikkelingsproces'
                            }
                        },
                        cases: [
                            'Miro',
                            'Museumnacht'
                        ]
                    },
                    contact: 'Sander Hidding'
                }
            },
            {
                template: 'work',
                content: {
                    header: {
                        size: 'large',
                        subtitle: {
                            eng: 'A highlight of our cases',
                            nl: 'Een overzicht van ons werk'
                        },
                        title: {
                            eng: 'Our work',
                            nl: 'Onze projecten'
                        }
                    },
                    overview: {
                        filter: true,
                        type: 'default'
                    },
                    logos: {
                        color: 'grey'
                    },
                    related: [
                        {
                            title: {
                                eng: 'Our work',
                                nl: 'Ons werk'
                            },
                            text: {
                                eng: 'Challenges we’ve solved',
                                nl: 'Uitdagingen die we hebben opgelost'
                            },
                            route: {
                                type: 'work'
                            }
                        },
                        {
                            title: {
                                eng: 'About us',
                                nl: 'Over ons'
                            },
                            text: {
                                eng: 'How we do what we do',
                                nl: 'Hoe we doen wat we doen'
                            },
                            route: {
                                type: 'about'
                            }
                        }
                    ]
                }
            },
            {
                template: 'team',
                content: {
                    header: {
                        size: 'medium',
                        subtitle: {
                            eng: 'We are Vruchtvlees',
                            nl: 'Wij zijn Vruchtvlees'
                        },
                        title: {
                            eng: 'Nice to meet you.',
                            nl: 'Leuk je te ontmoeten'
                        },
                        text: {
                            eng: 'We are a team of creatives with technical knowhow, strategists who think outside the box, and developers who push innovation. All working together like family in our studio in The Hague, the Netherlands.',
                            nl: 'We are a team of creatives with technical knowhow, strategists who think outside the box, and developers who push innovation. All working together like family in our studio in The Hague, the Netherlands.'
                        },
                        image: {
                            src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/thumbs/1440x_5cdd74d958a0b66cb6df1ca63cec7d0b35e1c711f335f.jpg',
                            caption: 'Vruchtvlees'
                        }
                    },
                    summary: {
                        size: 'medium',
                        subtitle: {
                            eng: 'Together, we can build the best solutions',
                            nl: 'Samen maken we de beste digitale producten'
                        },
                        title: {
                            eng: 'We focus on your challenges through kickass <i>brand design</i> & <i>strategy</i> while <i>developing</i> your most complex and desired web-apps.',
                            nl: 'We focus on your challenges through kickass <i>brand design</i> & <i>strategy</i> while <i>developing</i> your most complex and desired web-apps.'
                        },
                        button: {
                            href: '#',
                            text: {
                                eng: 'View our services',
                                nl: 'Bekijk onze diensten'
                            }
                        }
                    }
                }
            },
            {
                template: 'jobs',
                content: {
                    header: {
                        size: 'medium',
                        subtitle: {
                            eng: 'Jobs',
                            nl: 'Vacatures'
                        },
                        title: {
                            eng: 'Come work at Vruchtvlees.',
                            nl: 'Kom werken bij Vruchtvlees'
                        }
                    },
                    about: {
                        size: 'small',
                        text: {
                            eng: 'We realize the potential of ambitious brands and people. Enthusiastic and driven by design, we investigate the question behind the question. The result is Dutch Digital Design: award-winning (digital) solutions that people love and brands grow. Does that sound like something you’d like to become a part of?',
                            nl: 'We realize the potential of ambitious brands and people. Enthusiastic and driven by design, we investigate the question behind the question. The result is Dutch Digital Design: award-winning (digital) solutions that people love and brands grow. Does that sound like something you’d like to become a part of?'
                        }
                    },
                    team: {
                        title: {
                            eng: 'Our team',
                            nl: 'Ons team'
                        },
                        subtitle: {
                            eng: 'And you’ll get to work with these people',
                            nl: 'Dit worden je toekomstige collega\'s'
                        }
                    },
                    members: [
                        'Justine de Bruijn',
                        'Sander Hidding',
                        'Walewijn den Boer',
                        'Leendert van Duijvenbode',
                        'Giovanni Marchese',
                        'Ted Godyla',
                        'Yira Rodriguez Garcia',
                        'Roland Cos',
                    ],
                    blocks: [
                        {
                            type: 'text',
                            options: {
                                size: 'small',
                            },
                            content: {
                                subtitle: {
                                    eng: 'Why come work at Vruchtvlees?',
                                    nl: 'Waarom moet je bij Vruchtvlees werken?'
                                },
                                title: {
                                    eng: 'Well, why not?',
                                    nl: 'Nou waarom niet?'
                                },
                                text: {
                                    eng: 'This text area should screem your tone of voice while telling the user something about your culture. What makes vruchtvlees vruchtvlees and what’s it like to work at vruchtvlees. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis.',
                                    nl: 'This text area should screem your tone of voice while telling the user something about your culture. What makes vruchtvlees vruchtvlees and what’s it like to work at vruchtvlees. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis.'
                                }
                            }
                        },
                        {
                            type: 'parallax',
                            options: {
                                closed: true,
                                size: 'super',
                            },
                            content: {
                                images: [
                                    {
                                        alt: '',
                                        src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/uploads/5e452458ef8c7a013223c3d9620293106e715f13f16f3.jpg',
                                    },
                                    {
                                        alt: '',
                                        src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/uploads/5d14b35822b6326fc1ea0609558f7c5b5c79371ed55af.jpg',
                                    },
                                    {
                                        alt: '',
                                        src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/uploads/5d147cc89d8f611d3d702c7d922cd1732dbbdc2eb331a.jpg',
                                    },
                                    {
                                        alt: '',
                                        src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/uploads/5cdd6f88401394e4831ffb7f129a5ad17da1b856205b7.jpg',
                                    }
                                ]
                            }
                        },
                        {
                            type: 'text',
                            options: {
                                size: 'small',
                            },
                            content: {
                                title: {
                                    eng: 'Breathe Dutch Digital Design',
                                    nl: 'Wij leven Dutch Digital Design'
                                },
                                text: {
                                    eng: 'We realize the potential of ambitious brands and people. Enthusiastic and driven by design, we investigate the question behind the question. The result is Dutch Digital Design: award-winning (digital) solutions that people love and brands grow. Does that sound like something you’d like to become a part of?',
                                    nl: 'We realize the potential of ambitious brands and people. Enthusiastic and driven by design, we investigate the question behind the question. The result is Dutch Digital Design: award-winning (digital) solutions that people love and brands grow. Does that sound like something you’d like to become a part of?'
                                }
                            }
                        }
                    ]
                }
            },
            {
                template: 'contact',
                content: {
                    header: {
                        size: 'medium',
                        subtitle: {
                            eng: 'Vruchtvlees',
                            nl: 'Vruchtvlees'
                        },
                        title: {
                            eng: 'Digital, Strategy & Design',
                            nl: 'Digital, Strategy & Design'
                        },
                        image: {
                            src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/thumbs/1440x_5cdd74d958a0b66cb6df1ca63cec7d0b35e1c711f335f.jpg',
                            caption: 'Vruchtvlees'
                        }
                    },
                    call: {
                        button: {
                            href: '#',
                            text: {
                                eng: 'Call me back',
                                nl: 'Terugbellen'
                            }
                        }
                    }
                }
            },
        ]
    }
};

/** ----------------------------------------
    Export State
 ---------------------------------------- */

export default state;